<template>
  <div class="systemTree">
    <div class="custom-tree-container">
      <el-input
          v-model="filterText"
          style="width: 500px;"
          placeholder="输入关键字进行过滤"/>
      <div style="margin: 10px 0 0 10px; font-size: 14px; color: red;">剩余可用代码：{{unUsedIndex.join(', ')}}</div>
      <div style="margin: 20px 40px 20px 0px;">
        <el-button style="margin-bottom: 2%" type="primary" @click="$refs.editSystem.open(null, null, null, 1)">新建一级</el-button>
        <el-tree
            ref="tree"
            :data="data"
            :props="defaultProps"
            :filter-node-method="filterNode"
            node-key="id"
            :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span>{{data.label+"("+data.other+")"}}</span>
            <span>
              <el-button
                  type="text"
                  style="margin-left: 40px;"
                  icon="el-icon-circle-plus"
                  @click="append(data)"/>
              <el-button
                  type="text"
                  style="margin-left: 10px;"
                  icon="el-icon-edit"
                  @click="edit(node, data)"/>
              <el-button
                  v-if="!data.children"
                  type="text"
                  style="margin-left: 10px;"
                  icon="el-icon-delete"
                  @click="remove(data)"/>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <system-function-edit ref="editSystem" @save-success="getData()"/>
  </div>
</template>
  <script>
  import SystemFunctionEdit from "@/views/SystemInfo/systemFunction/SystemFunctionEdit.vue";

  export default {
    name:"SystemFunctionTree",
    components: {SystemFunctionEdit},
    data() {
      return {
        data: [],
        unUsedIndex: [],
        filterText: "",
        defaultProps: {
          children: "children",
          label: "",
          other: "",
        },
      };
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.$http
          .get("basic","functions/tree").then((res) => {
            this.data = res;
          });
        this.$http
          .get("basic","functions/unUsed").then((res) => {
            if (res && res.length > 0) {
              this.unUsedIndex = res;
            }
          });
      },
      filterNode(value, data, node) {
        console.log(data);
        if (!value) {
          return true;
        }
        if (node.parent.parent !== null && node.parent.visible) {
          return true;
        }
        return data.label.indexOf(value) !== -1;
      },
      append(data) {
        this.$refs.editSystem.open(data.id, null, null, 0);
      },
      edit(node, data) {
        this.$refs.editSystem.open(node.parent.data.id, data.id, data.label, 0);
      },
      remove(data) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","functions", data.id).then(() => {
            this.getData();
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .systemTree{
    .custom-tree-node {
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
  }

</style>
